<template>
    <div style="display:inline">
        <button type="submit" @click="showModalTemp()" class="btn btn-cancel" style="margin: 15px; margin-top: 15px; margin-bottom: 0px;">
            Send
        </button>
        <!--<span @click="showModalTemp()"
              style="
                              width: 30px;
                              height: 30px;
                              border-radius: 5px;
                              background-color: #212121;
                              color: white;
                              display: inline-block;
                              padding-left: 5px;
                              padding-right: 5px;
                              text-align: center;
                              cursor:pointer;
                              margin-right: 8px;
                              ">
            <i class="fa fa-plus" style="margin-top:7px;" aria-hidden="true"></i>
        </span>-->
        <modal :scrollable="true" name="send-invoice-form" @before-open="beforeOpen" height="auto" :minHeight="800" width="40%">

            <div class="" id="sendInvoice" role="dialog">
                <div class="">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div style="padding:15px;">
                            <div class="row">
                                <div class="col-8">
                                    <div class="text-left section-title" style="padding: 5px;">
                                        <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                                            <template v-if="buildingId">
                                                <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                                            </template>
                                            Form
                                        </span>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="text-right" style="padding: 5px;">
                                        <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="hide()"><i class="fas fa-times"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <label>Email To: *</label>
                                    <input type="text" v-model="emailTo" placeholder="Email Address" class="form-control" />
                                    <div v-show="submitted && !name" class="invalid-feedback">
                                        Expense type name is required
                                    </div>
                                </div>
                                <div class="col-md-12 ">
                                    <label>Message: </label>
                                    <textarea type="text" row="3" class="form-control" v-model="message"></textarea>


                                </div>
                            </div>

                            <div class="text-right">
                                <button type="submit" @click.prevent="sendInvoice()" class="btn btn-submit" style="margin: 15px;">
                                    Submit
                                </button>
                                <button @click.prevent="hide()" class="btn btn-cancel">Cancel</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import { mapState } from "vuex";
    export default {
        props: ["invoiceId"],
        data: function () {
            return {
                type: 1,
                emailTo: '',
                message:''
            };
        },

        mounted() {
            this.buildingId = this.buildingId;
            //alert(this.buildingId);
        },

        methods: {
            sendInvoice() {
                this.$http
                    .post("/report/generatepdf", {
                        invoiceId: this.invoiceId,
                        emailTo: this.emailTo,
                        message: this.message,
                    })
                    .then(
                        () => {
                            this.hide();
                           
                        },
                        () => {
                             alert('error')
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                        }
                    );
            },
            beforeOpen(event) { },
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            fetchStatement: function () { },
            showModalTemp: function () {
                this.$modal.show("send-invoice-form");
                //alert("Id " + expenseId + " month " + month);
                //this.isModalVisible = true;
            },
            show() {
                this.$modal.show("send-invoice-form");
            },
            hide() {

                this.$modal.hide("send-invoice-form");
            },

            /**
             * Prepare the component.
             */
        },

        computed: {
            ...mapState({
                building: (state) => state.building.currentBuilding,
                buildings: (state) => state.building.buildings,
                numberOfAllowedBuildings: (state) =>
                    state.building.numberOfAllowedBuildings,
            }),
            buildingName() {
                if (this.building != null)
                    return this.building.name;
                return ""
            },

        },
    }; // Our Javascript logic
</script>